
const  audios=[
    {
        src:'song/aplacetocallhome.mp3',
        title: 'A Place To Call Home',
        author:'Violet Evergarden OST',
        img:'image/img1.jpg'
    },
    {
        src:'song/atownwithanoceanview.mp3',
        title: 'A Town With An Ocean View',
        author:'Ghibli OST',
        img:'image/img2.jpg'
    },
    {
        src:'song/fiction.mp3',
        title: 'Fiction',
        author:'Unknown',
        img:'image/img3.jpg'
    },
    {
        src:'song/firstdate.mp3',
        title: 'First Date',
        author:'Frad',
        img:'image/img4.jpg'
    },
    {
        src:'song/illbefine.mp3',
        title: 'I Will Be Fine ',
        author:'WYS',
        img:'image/img5.jpg'
    },
    {
        src:'song/kiminonawa.mp3',
        title: 'Kimi No Nawa',
        author:'Your Name OST',
        img:'image/img6.jpg'
    },
    {
        src:'song/latenight.mp3',
        title: 'Late Night',
        author:'Melancholy',
        img:'image/img7.jpg'
    },
    {
        src:'song/raingardenofwords.mp3',
        title: 'Rain',
        author:'Garden of Words OST',
        img:'image/img8.jpg'
    },
    {
        src:'song/refrain.mp3',
        title: 'Refrain',
        author:'Anan Ryoko',
        img:'image/img9.jpg'
    },
    {
        src:'song/thelongnight.mp3',
        title: 'The Long Night',
        author:'Violet Evergarden OST',
        img:'image/img10.jpg'
    },
    {
        src:'song/thevoiceinmyheart.mp3',
        title: 'The Voice In My Heart',
        author:'Violet Evergarden OST',
        img:'image/img11.jpg'
    },
    {
        src:'song/whileyouwereaway.mp3',
        title: 'While You Were Away',
        author:'Frad',
        img:'image/img12.jpg'
    }
];
export default audios;

